import './tailwind.css'
import { Auth0Provider } from '@auth0/auth0-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import LoadingSpinner from './components/general/LoadingSpinner'
import { REACT_APP_STORE_AUTH0_DOMAIN, REACT_APP_STORE_AUTH0_CLIENT_ID } from './constants'
import queryClient from './queryClient'
import { store } from './redux/storeConfig/store'

const appRootContainer = document.getElementById('root')
const root = createRoot(appRootContainer)

const currentUrl = window.location.href
const auth0RedirectUri = currentUrl.replace(/log-in$/, 'auth0_callback')

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Auth0Provider
        domain={REACT_APP_STORE_AUTH0_DOMAIN}
        clientId={REACT_APP_STORE_AUTH0_CLIENT_ID}
        redirect_uri={auth0RedirectUri}
      >
        <Router>
          <Suspense fallback={<LoadingSpinner />}>
            <App />
          </Suspense>
        </Router>
      </Auth0Provider>
    </Provider>
  </QueryClientProvider>
)

// unregister()
